import React, { useContext } from 'react';
import { Field } from 'formik';
import { appendValidationClassNames } from './utils';
import { FormContext } from './FormContext';
const CheckBoxField = React.forwardRef((props, ref) => {
  const context = useContext(FormContext);
  const { disabled, readOnly } = context ? context : {};
  const extProps = { disabled, readOnly, ...props };

  return (
    <Field
      {...extProps}
      ref={ref}
      render={({ field: { name, value, onChange, onBlur }, form: { errors, touched } }) => {
        const classes = appendValidationClassNames(props.className, touched, errors, name);

        return (
          <input
            name={name}
            {...extProps}
            type="checkbox"
            checked={value}
            onChange={(e) => {
              onChange(e);

              if (typeof props.onChange === 'function') {
                props.onChange(e);
              }
            }}
            onBlur={onBlur}
            className={classes}
          />
        );
      }}
    />
  );
});

CheckBoxField.displayName = 'CheckBoxField';
export default CheckBoxField;
